export const fmtCountdown = (ms: number): string => {
  const s = Math.ceil(ms / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const sanitize = (s: string): string =>
  s.replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 16);
